var exports = {
  "kL": "x620889e6--bf51bc--container",
  "mr": "x620889e6--bf51bc--cost-header",
  "bn": "x620889e6--bf51bc--cost-for-all-office-container",
  "WH": "x620889e6--bf51bc--coworking-profit-banner-container",
};

module.exports = exports;
